import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button, Dialog, Link, Space } from 'tdesign-react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import Descriptions from '@/components/Descriptions';
import { fetchFrontConfig } from '@/slices/platformSlice';

function Modal({ visible, handleClose, fetchFrontConfig, frontConfig }) {
  useEffect(() => {
    fetchFrontConfig();
  }, [fetchFrontConfig]);

  return (
    <Dialog
      visible={visible}
      onClose={handleClose}
      header={null}
      closeBtn={null}
      footer={null}
      width={500}
      style={{ padding: 0, overflow: 'hidden', borderRadius: 16 }}
    >
      <Root>
        <Icon src={frontConfig['about-logo']} />
        <Title>{frontConfig['about-title']}</Title>
        <SubTitle>Copyright © 2023-{dayjs().format('YYYY')} 上海谙流科技有限公司 版权所有</SubTitle>
        <Space size='small'>
          {frontConfig['about-agreement'] && (
            <Link
              theme='primary'
              size='small'
              target='_blank'
              href={frontConfig['about-agreement']}
            >
              《软件许可及服务协议》
            </Link>
          )}
          {frontConfig['about-privacy-policy'] && (
            <Link
              theme='primary'
              size='small'
              target='_blank'
              href={frontConfig['about-privacy-policy']}
            >
              《隐私保护指引》
            </Link>
          )}
        </Space>
        <Descriptions column={1}>
          <Descriptions.Item label='版本号' value={`Version ${process.env.REACT_APP_VERSION}`} />
          <Descriptions.Item label='更新时间' value={process.env.REACT_APP_RELEASE_DATE} />
        </Descriptions>
        <Button
          size='large'
          theme='primary'
          block
          style={{ marginTop: 22, height: 48, fontWeight: 700 }}
          onClick={handleClose}
        >
          知道了
        </Button>
      </Root>
    </Dialog>
  );
}

export default connect(
  (state) => ({
    frontConfig: state.platform.frontConfig,
  }),
  {
    fetchFrontConfig,
  },
)(Modal);

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f7f8fa;
  margin: -16px 0;
  padding: 32px 50px;
  .descriptions {
    margin-top: 18px;
    .description-value {
      width: auto;
      font-size: 12px;
      padding-left: 8px;
    }
    .description-label {
      flex: 1;
      text-align: right;
      padding-right: 8px;
      font-size: 12px;
    }

    .t-col {
      padding: 0;
    }
  }
`;

const Icon = styled.img`
  width: 80px;
  height: auto;
  margin-top: 16px;
  margin-bottom: 30px;
  border-radius: 16px;
  box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 8px 10px -6px rgba(0, 0, 0, 0.1);
  padding: 6px;
  box-sizing: border-box;
`;

const Title = styled.div`
  color: var(--td-text-color-primary);
  font-family: PingFang SC;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin: -4px 0 4px;
`;

const SubTitle = styled.div`
  color: var(--td-text-color-secondary);
  font-size: 12px;
  line-height: 2.6;
`;
